import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { Error } from "@material-ui/icons";

const styles = (theme) => ({
  severityWarning: {
    fill: theme.warningColor,
    paddingRight: "4",
    fontSize: "21px",
  },
  severityError: {
    fill: theme.ErrorMessageColor,
    paddingRight: "4",
    fontSize: "21px",
  },
  iconContainer: {
    display: "flex",
    alignItems: "center",
    boxSizing: "border-box",
    paddingTop: "4px ",
  },
  value: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: "19px",
    color: theme.iconColor,
  },
});

const SeverityIcon = ({ classes, severity }) => (
  <div className={classes.iconContainer}>
    <Error
      className={
        severity === "L" ? classes.severityWarning : classes.severityError
      }
    />
    <span className={classes.value}>{severity === "L" ? "Low" : "High"}</span>
  </div>
);

export default withStyles(styles)(SeverityIcon);
